module.exports = require("@babel/runtime-corejs2/helpers/assertThisInitialized");